import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { apps } from "@/config/apps";

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t bg-muted/30">
      <div className="mx-auto max-w-6xl px-4 py-12">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <div className="flex -space-x-1">
                {apps.map((app) => (
                  <div
                    key={app.id}
                    className={`flex h-5 w-5 items-center justify-center rounded-full ${app.colorClass} text-white ring-2 ring-background`}
                  >
                    <app.icon className="h-2.5 w-2.5" />
                  </div>
                ))}
              </div>
              <span className="font-bold">Tabipla</span>
            </div>
            <p className="mt-2 text-sm text-muted-foreground">旅行をもっと楽しく</p>
          </div>

          {/* Apps */}
          <div>
            <h3 className="mb-3 font-semibold">{t("common.apps")}</h3>
            <ul className="space-y-2">
              {apps.map((app) => (
                <li key={app.id}>
                  <a
                    href={app.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-muted-foreground hover:text-primary"
                  >
                    {app.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="mb-3 font-semibold">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-sm text-muted-foreground hover:text-primary">
                  {t("common.terms")}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-primary">
                  {t("common.privacy")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="mb-3 font-semibold">Contact</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="mailto:support@tabipla.com"
                  className="text-sm text-muted-foreground hover:text-primary"
                >
                  support@tabipla.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 border-t pt-8 text-center text-sm text-muted-foreground">
          {t("common.copyright")}
        </div>
      </div>
    </footer>
  );
}
